var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "right", trigger: "click" } },
    [
      _c(
        "el-form",
        {
          ref: "tabsStyleForm",
          staticClass: "de-form-item",
          attrs: { model: _vm.styleInfo, size: "small" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "头部字体颜色", prop: "headFrontColor" } },
            [
              _c(
                "div",
                {
                  staticClass: "picker-color-div",
                  on: {
                    click: function ($event) {
                      return _vm.triggerTheme("headFontColor")
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "theme-input",
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.styleInfo.headFontColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "headFontColor", $$v)
                        },
                        expression: "styleInfo.headFontColor",
                      },
                    },
                    [
                      _c("el-color-picker", {
                        ref: "headFontColorPicker",
                        staticClass: "theme-picker",
                        attrs: { slot: "prefix" },
                        on: { change: _vm.styleChange },
                        slot: "prefix",
                        model: {
                          value: _vm.styleInfo.headFontColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "headFontColor", $$v)
                          },
                          expression: "styleInfo.headFontColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "头部字体选中颜色", prop: "headFontActiveColor" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "picker-color-div",
                  on: {
                    click: function ($event) {
                      return _vm.triggerTheme("headFontActiveColor")
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "theme-input",
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.styleInfo.headFontActiveColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "headFontActiveColor", $$v)
                        },
                        expression: "styleInfo.headFontActiveColor",
                      },
                    },
                    [
                      _c("el-color-picker", {
                        ref: "headFontActiveColorPicker",
                        staticClass: "theme-picker",
                        attrs: { slot: "prefix" },
                        on: { change: _vm.styleChange },
                        slot: "prefix",
                        model: {
                          value: _vm.styleInfo.headFontActiveColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "headFontActiveColor", $$v)
                          },
                          expression: "styleInfo.headFontActiveColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: "头部边框颜色", prop: "headBorderColor" } },
            [
              _c(
                "div",
                {
                  staticClass: "picker-color-div",
                  on: {
                    click: function ($event) {
                      return _vm.triggerTheme("headBorderColor")
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "theme-input",
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.styleInfo.headBorderColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "headBorderColor", $$v)
                        },
                        expression: "styleInfo.headBorderColor",
                      },
                    },
                    [
                      _c("el-color-picker", {
                        ref: "headBorderColorPicker",
                        staticClass: "theme-picker",
                        attrs: { slot: "prefix" },
                        on: { change: _vm.styleChange },
                        slot: "prefix",
                        model: {
                          value: _vm.styleInfo.headBorderColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.styleInfo, "headBorderColor", $$v)
                          },
                          expression: "styleInfo.headBorderColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "头部边框选中颜色",
                prop: "headBorderActiveColor",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "picker-color-div",
                  on: {
                    click: function ($event) {
                      return _vm.triggerTheme("headBorderActiveColor")
                    },
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "theme-input",
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.styleInfo.headBorderActiveColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.styleInfo, "headBorderActiveColor", $$v)
                        },
                        expression: "styleInfo.headBorderActiveColor",
                      },
                    },
                    [
                      _c("el-color-picker", {
                        ref: "headBorderActiveColorPicker",
                        staticClass: "theme-picker",
                        attrs: { slot: "prefix" },
                        on: { change: _vm.styleChange },
                        slot: "prefix",
                        model: {
                          value: _vm.styleInfo.headBorderActiveColor,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.styleInfo,
                              "headBorderActiveColor",
                              $$v
                            )
                          },
                          expression: "styleInfo.headBorderActiveColor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("detabs.head_position") } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.styleInfo.headPosition,
                    callback: function ($$v) {
                      _vm.$set(_vm.styleInfo, "headPosition", $$v)
                    },
                    expression: "styleInfo.headPosition",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                  ]),
                  _c("el-radio-button", { attrs: { label: "center" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.text_pos_center"))),
                  ]),
                  _c("el-radio-button", { attrs: { label: "right" } }, [
                    _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("panel.carousel") } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { size: "mini" },
                          on: { change: _vm.styleChange },
                          model: {
                            value: _vm.styleInfo.carouselEnable,
                            callback: function ($$v) {
                              _vm.$set(_vm.styleInfo, "carouselEnable", $$v)
                            },
                            expression: "styleInfo.carouselEnable",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("commons.enable")) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "padding-right": "10px",
                      },
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("panel.switch_time")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "hide-icon-number number-padding",
                          attrs: {
                            disabled: !_vm.styleInfo.carouselEnable,
                            type: "number",
                            size: "mini",
                            min: 2,
                            max: 3600,
                          },
                          on: { change: _vm.switchTimeChange },
                          model: {
                            value: _vm.styleInfo.switchTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.styleInfo, "switchTime", $$v)
                            },
                            expression: "styleInfo.switchTime",
                          },
                        },
                        [_c("template", { slot: "append" }, [_vm._v("S")])],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("i", {
        staticClass: "iconfont icon-tabs",
        attrs: { slot: "reference" },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }